<template>

  <div class="workspace-tags-picker">

    <div v-for="category in workspaceTags" :key="category.id" class="workspace-tags-picker__category">

      <h4 class="workspace-tags-picker__cat-name">

        <span>{{ category.nome }}</span>

        <span class="workspace-tags-picker__count">{{ (category.tags || []).length }}</span>

      </h4>

      <div class="workspace-tags-picker__list">
        <WorkspaceTagChip
          v-for="tag in category.tags || []"
          :key="tag.id"
          :tag="tag"
          :selected="isSelected(tag.id)"
          interactive
          @click="toggle(tag.id)"
        />
      </div>

    </div>

    <div v-if="!workspaceTags.length" class="workspace-tags-picker__empty">

      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/></svg>

      <p>{{ t('kanban.taskDetail.sections.tags.empty') }}</p>

    </div>

  </div>

</template>



<script setup>

import { useI18n } from 'vue-i18n'

import WorkspaceTagChip from '@/components/cliente/WorkspaceTagChip.vue'



const props = defineProps({

  workspaceTags: { type: Array, default: () => [] },

  modelValue: { type: Array, default: () => [] }

})



const emit = defineEmits(['update:modelValue'])



const { t } = useI18n()



const isSelected = (id) => props.modelValue.map(Number).includes(Number(id))



const toggle = (id) => {

  const n = Number(id)

  const next = [...props.modelValue.map(Number)]

  const idx = next.indexOf(n)

  if (idx >= 0) next.splice(idx, 1)

  else next.push(n)

  emit('update:modelValue', next)

}

</script>



<style scoped>

.workspace-tags-picker__category + .workspace-tags-picker__category {

  margin-top: 0.875rem;

}

.workspace-tags-picker__cat-name {

  display: flex;

  align-items: center;

  gap: 0.5rem;

  font-size: 0.8125rem;

  font-weight: 600;

  color: var(--text-secondary);

  margin: 0 0 0.5rem;

}


.workspace-tags-picker__count {

  font-size: 0.6875rem;

  padding: 0.125rem 0.375rem;

  border-radius: 4px;


}

.workspace-tags-picker__list {

  display: flex;

  flex-wrap: wrap;

  gap: 0.375rem;

}

.workspace-tags-picker__empty {

  text-align: center;

  padding: 1.5rem 0.5rem;

  color: #94a3b8;

}

.workspace-tags-picker__empty svg {

  width: 2.5rem;

  height: 2.5rem;

  margin: 0 auto 0.5rem;

  opacity: 0.5;

}

</style>

